
/**
 * Loader API Version: 2
 * Is this in "webpack mode": true
 */
export default {
  "getConnected": {
    "title": "Get Connected",
    "description": "Connect your Privacy Hero router to your main router just like in the video below",
    "ok": "I'm Connected"
  },
  "activate": {
    "title": "Activate Your Router",
    "loadingMessage": "Hang tight, this may take a few moments",
    "updatingMessage": "Your PrivacyHero router is updating its firmware. Please wait a minute and then retry. Important: Do not disconnect the power or the ethernet cable.",
    "needsRebootMessage": "Your PrivacyHero router is updated to the latest firmware but needs to be restarted to continue the activation process. Please disconnect it from the power, wait for 5 seconds and reconnect again. Do not unplug the ethernet cable.",
    "offlineMessage": "Your PrivacyHero router is offline. Please check it is powered on and then retry.",
    "instructions": "Enter the 5 digit activation code located on the back of your router",
    "codeLabel": "Activation Code",
    "codePlaceholder": "XXXXX",
  },
  "notFound": {
    "header": "Oops",
    "title": "Router not found",
    "details": "Try following the setup steps again, or contact support.",
    "goBack": "Try again",
    "help": "Help"
  },
  "createNetwork": {
    "title": "Create WIFI",
    "ok": "OK",
    "next": "Next",
    "description": "We will create 2 separate WIFI networks for you (5GHz and 2.4Ghz)"
  },
  "choosePlan": {
    "title": "Choose how you'd like to continue your Privacy Hero service",
    "pageIntroShort": "Your router includes 1 year of Privacy Premium and NordVPN Standard. Choose how you'd like to continue after your included year.",
    "pageIntroRouterIncludesHeading": "Your router includes:",
    "pageIntroRouterIncludesBullet1": "1 year of Privacy Premium",
    "pageIntroRouterIncludesBullet2": "1 year of NordVPN Standard with Threat Protection Pro",
    "pageIntroIncludedServiceStarts": "Your included service starts now.",
    "pageIntroActivationInstructions": "To complete activation, choose how your service will continue after your included year and add a payment method.",
    "pageIntroLockInPricing": "Lock in discounted pricing today, or continue at standard pricing later.",
    "pageIntroNoChargeToday": "You will not be charged today unless you choose a prepaid option.",
    "noPlansAvailable": "No plans are available right now. Please try again later.",
    "unnamedPlan": "Plan",
    "renewalToggleLabel": "Renewal option",
    "prepayNowSave": "Prepay Now & Save",
    "renewLaterToggle": "Renew Later",
    "sectionPrivacyCore": "Privacy Core",
    "sectionPrivacyPremium": "Privacy Premium",
    "columnOneYearPrepaid": "1 Year Prepaid",
    "columnTwoYearsPrepaid": "2 Years Prepaid",
    "columnOneYear": "1 Year",
    "columnTwoYears": "2 Years",
    "columnMonthly": "Monthly",
    "badgeMostPopular": "Most Popular",
    "badgeBestValue": "Best Value",
    "currentPlanBadge": "Your Current Plan",
    "saveLabel": "Save {{amount}} ({{percent}}%)",
    "regularLabel": "Regular {{amount}}{{cadence}}",
    "expandFeatures": "Show plan features",
    "collapseFeatures": "Hide plan features",
    "noFeatureDetails": "No additional feature details are available for this plan.",
    "bundlingFootnote": "When NordVPN is bundled, it renews together with your Privacy Hero plan for the same term.",
    "priceCadencePrepaid": "prepaid",
    "priceCadenceMonthly": "/ month",
    "priceCadenceYearly": "/ year",
    "priceCadenceTwoYears": "/ 2 years",
    "priceCadenceMonthlyShort": "/mo",
    "priceCadenceYearlyShort": "/yr",
    "priceCadenceTwoYearsShort": "/2yr",
    "continue": "Continue",
    "continueToPayment": "Continue to Payment",
    "loadingPaymentForm": "Loading payment form…",
    "connectDeviceToContinue": "Error, no claimed device, please contact customer support",
    "planTwinUnavailable": "This prepaid plan could not be matched to a subscription price. Please choose a different plan or contact support.",
    "addPaymentMethodTitle": "Add Payment Method",
    "addPaymentMethodRequired": "A payment method is required to complete activation.",
    "addPaymentMethodUsedFor": "It will be used for:",
    "addPaymentMethodBulletPrepaid": "Your prepaid purchase (if selected), or",
    "addPaymentMethodBulletRenewal": "Automatic renewal when your plan begins",
    "addPaymentMethodNoCharge": "You will not be charged today unless you selected a prepaid option.",
    "billingAddendum1": "Your plan will automatically renew at the end of your term to avoid service interruption.",
    "billingAddendum2": "You can cancel anytime from your account."
  },
  "allSet": {
    "title": "Activation Complete",
    "lineActive": "Your Privacy Hero is now active and ready to use.",
    "lineIncluded": "Your included 1-year Privacy Premium service has started.",
    "linePlanBegins": "Your selected plan will begin automatically after your included year ends.",
    "nordHeadline": "You have a NordVPN code available.",
    "nordSubtext": "You can claim it now or anytime later from your account.",
    "claimNordCodeButton": "Claim {{codeType}} code",
    "newsletterMessage": "Send me product updates and feature alerts.",
    "dashboardHint": "You can manage your plan, billing, and devices anytime from your dashboard.",
    "goToDashboard": "Go to Dashboard"
  },
  "steps": {
    "connect": "Connect",
    "activate": "Activate",
    "activateSubscription": "Subscription",
    "setupWifi": "WIFI",
    "allSet": "All Set"
  }
}